<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img v-if="setResetPasswordPageImage" :src="img_cdn + setResetPasswordPageImage" alt="login" class="mx-auto">
            </div>


            <div v-if="verifyEmailStatus" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">

                  <h4 class="mb-4">Update Password</h4>
                  <!--                  <p>Your are re.</p>-->
                  <br>
                </div>

                <div>
                  <br>
<!--                  <vs-input-->
<!--                    v-validate="'required|email'"-->
<!--                    name="email"-->
<!--                    icon-no-border-->
<!--                    icon="icon icon-user"-->
<!--                    icon-pack="feather"-->
<!--                    label-placeholder="Enter Email"-->
<!--                    v-model="DataEmail"-->
<!--                    class="w-full"/>-->
<!--                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>-->
                  <vx-input-group>
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                  v-model="DataNewPassword" 
                   data-vv-validate-on="blur"
                   v-validate="'required|min:6|max:20'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    placeholder="New Password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    class="w-full no-right-border"
                  />
                </vx-input-group>
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                  <vs-input
                    type="password"
                    v-validate="'min:6|max:20|confirmed:password'"
                    data-vv-validate-on="blur"
                    data-vv-as="password"
                    name="confirm_password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Confirm Password"
                    placeholder="Confirm New Password"
                    v-model="dataConfPassword"
                    class="w-full mt-6" />
                  <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>


                  <br>

                  <router-link to="/login">
                    <vs-button type="border">Cancel</vs-button>
                  </router-link>
                  <vs-button class="float-right" :disabled="!validateForm" @click.native="submitData">Reset Password</vs-button>
                  <br>
                </div>
              </div>
            </div>

            <div v-if="sentSuccess" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Password updated successfully</h4>
                  <!--                  <p>Your are re.</p>-->
                </div>
                <div>

                  <br>
                  <router-link to="/login">
                    <vs-button class="float-right" type="border">Login</vs-button>
                  </router-link>
<!--                  <vs-button class="float-right" @click="submitData">Login</vs-button>-->
                  <br>
                </div>
              </div>
            </div>


          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {GET_IMAGE_SETTING, PASSWORD_UPDATE_BY_EMAIL} from '@/graphql'


export default {
  data () {
    return {
      sentSuccess:false,
      verifyEmailStatus:true,

      DataEmail:'',
      DataToken:'',
      DataNewPassword:'',
      dataConfPassword:'',
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      setResetPasswordPageImage:'',
      showPassword:false


    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.DataNewPassword !== '' && this.dataConfPassword !== ''
    }
  },
  methods: {

    submitData () {
      this.$apollo
        .mutate({
          mutation: PASSWORD_UPDATE_BY_EMAIL,
          variables: {
            token: this.DataToken,
            password: this.DataNewPassword,
            password_confirmation: this.dataConfPassword
          }
        })
        .then(response => {
          if (response.data.updateForgottenPassword.status == 'SUCCESS') {

            this.verifyEmailStatus = false
            this.sentSuccess = true
            // this.$router.replace('/login')
            this.SuccessStatus()
          } else if (response.data.updateForgottenPassword.status == 'NOT_FOUND') {
            var title = 'Not Found'
            this.InvalidDataNotification(title, response.data.updateForgottenPassword.message)

          } else if (response.data.updateForgottenPassword.status == 'TOKEN_EXPIRED') {
            var title = 'Token Expired'
            this.InvalidDataNotification(title, response.data.updateForgottenPassword.message)

          }
        }).catch(error => {
          this.invalidEmail = true
          this.verifyEmailStatus = true
          this.StatusInvalid()
        })

    },
    SuccessStatus () {
      this.$vs.notify({
        title: 'Password Updated!',
        text: 'Your password has been reset.',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusInvalid () {

      this.$vs.notify({
        title: 'Incorrect Data',
        text: 'Check and Enter again',
        color: 'danger',
        position: 'top-right'
      })
    },
    InvalidDataNotification (title, message) {

      this.$vs.notify({
        title,
        text: message,
        color: 'danger',
        position: 'top-right'
      })
    }

  },
  beforeCreate () {
    this.$apollo
      .query({
        query: GET_IMAGE_SETTING
      })
      .then(response => {
        if (response.data.getImagesSetting.reset_password_page_image != null) {
          this.setResetPasswordPageImage = response.data.getImagesSetting.reset_password_page_image
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  created () {
    this.DataToken = this.$route.query.token


  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
